import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuropeanDatePipe } from './european-date.pipe';
import { HasAllGroupsPipe } from './has-all-groups.pipe';
import { HasAllPermsPipe } from './has-all-perms.pipe';
import { HasEitherGroupPipe } from './has-either-group.pipe';
import { HasEitherPermPipe } from './has-either-perm.pipe';
import { TimePastPipe } from './time-past.pipe';

@NgModule({
  imports: [CommonModule, EuropeanDatePipe],
  declarations: [
    HasAllPermsPipe,
    HasEitherPermPipe,
    HasAllGroupsPipe,
    HasEitherGroupPipe,
    TimePastPipe,
  ],
  exports: [
    EuropeanDatePipe,
    HasAllPermsPipe,
    HasEitherPermPipe,
    HasAllGroupsPipe,
    HasEitherGroupPipe,
    TimePastPipe,
  ],
  providers: [
    HasAllPermsPipe,
    HasEitherPermPipe,
    HasAllGroupsPipe,
    HasEitherGroupPipe,
    TimePastPipe,
  ],
})
export class PipesModule {}
